import {Box, CircularProgress} from '@mui/material';
import {useBoardRedux, useSessionRedux, useWorkSpaceRedux} from 'hooks';
import {useUpdateTenantUserIsDefault} from 'hooks/useTenant';
import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {appRoutes} from 'routes';
import {sessionSelector} from 'store/auth/sessionSlice';

export const LoadSelectTenant = () => {
    const {updateDefaultTenant} = useSessionRedux();
    const {userId, tenantSlug} = useSelector(sessionSelector);
    const {
        updateUsersDefaultTenant,
        updateUserDefaultTenantLoading,
        updateUserDefaultTenantResponse,
        updateUserDefaultTenantError,
    } = useUpdateTenantUserIsDefault();
    const {selectedBoard} = useBoardRedux();
    const {selectedWorkSpace} = useWorkSpaceRedux();

    const {tenantId} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (tenantId && tenantId !== ':tenantId') {
            updateUsersDefaultTenant({variables: {request: {userId: userId, tenantSlug: tenantId}}});
        }
    }, [tenantId]);

    useEffect(() => {
        if (!updateUserDefaultTenantLoading && updateUserDefaultTenantResponse) {
            updateDefaultTenant(updateUserDefaultTenantResponse);
        }
    }, [updateUserDefaultTenantLoading, updateUserDefaultTenantResponse]);

    useEffect(() => {
        if (updateUserDefaultTenantError) {
            if (selectedWorkSpace && selectedBoard && tenantSlug) {
                navigate(appRoutes.workspace.boardListing(tenantSlug, selectedWorkSpace.slug, selectedBoard.slug));
            }
        }
    }, [updateUserDefaultTenantError]);

    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh" width="100vw" bgcolor="#fff">
            <CircularProgress />
        </Box>
    );
};

export default LoadSelectTenant;
